export type AbsoluteDateTimeType = 'dateRange' | 'beforeDate' | 'afterDate' | 'chooseDate' | 'chooseDateTime';
export type RelativeDateTimeType = 'relativeDatePreset' | 'relativeDateRange';
export type DateTimeType = AbsoluteDateTimeType | RelativeDateTimeType;

export function isAbsoluteDateTimeType (dateTimeType: DateTimeType) {
  switch (dateTimeType) {
    case 'afterDate':
    case 'beforeDate':
    case 'dateRange':
    case 'chooseDate':
    case 'chooseDateTime':
      return true;
  }
  return false;
}

export function isRelativeDateTimeType (dateTimeType: DateTimeType) {
  switch (dateTimeType) {
    case 'relativeDateRange':
    case 'relativeDatePreset':
      return true;
  }
  return false;
}

export function isIntervalAbsoluteDateTimeType (dateTimeType: DateTimeType) {
  switch (dateTimeType) {
    case 'afterDate':
    case 'beforeDate':
    case 'dateRange':
      return true;
  }
  return false;
}
